/*
 * @Author: zhuyan 
 * @Date: 2021-4-27 09:53:34 
 * 模块名称: 已支付-公司内部往来款
 */

import React, { useState, useEffect, useRef } from 'react'
import api from '@/api'
import { Link } from 'react-router-dom'
import { Table, Button, Alert, Drawer } from 'antd'
import FormNoheader from '@/components/FormNoheader'
import Export from '@/components/Export'
import { parseSearch, cryptoParamsIntoUrl } from '@/utils'
import Auth from '@/components/AuthMiddleware'
import EditPayment from './EditPayment'

// 导出用：筛选条件初始值
let exporfilter = {}

const InternalAccount = (props) => {
  const { history, match, location } = props
  const search = parseSearch(location.search)
  const initParams = {
    // companyId: 1,
    page: search.page || 1,
    limit: search.limit || 10,
  }
  const [states, setStates] = useState({
    dataSource: [], // 列表
    loading: true,
    total: 0, // 总条数
    filter: {
      fromAccountId: [], // 转出账户
      fromCompanyId: [], // 转出主体
      toAccountId: [], // 转入账户
      toCompanyId: [] // 转入主体
    },
    // 筛选条件：列表接口参数
    params: initParams,
  })
  const { dataSource, filter, loading, total, params } = states
  const productsRef = useRef()
  const [showExport, setShowExport] = useState(false) // 显示导出浮层
  const [authList, setAuthList] = useState([]) // 按钮权限
  const [editVisible, setEditVisible] = useState(false)
  const [editData, setEditData] = useState({})

  useEffect(() => {
    getList()
    const { page, limit, ...others } = params
    exporfilter = { ...others }
  }, [params])

  useEffect(() => {
    getPageAuth()
  }, [])

  // 获取列表
  const getList = () => {
    api
      .getInnerFundTransferHasCloseList(params)
      .then((res) => {
        setStates((current) => ({
          ...current,
          loading: false,
          dataSource: res.list,
          total: res.count,
        }))
      })
      .catch(() => {
        setStates((current) => ({
          ...current,
          loading: false,
        }))
      })
  }

  // 获取按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then((list) => {
      setAuthList(list)
    })
  }

  // 转出账户筛选
  const getFromAccount = () => {
    api.getInnerFundTransferAccount().then(data => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          fromAccountId: data.list,
        },
      }))
    })
  }

  // 转出主体 
  const getFromtCompanyList = () => {
    api.getAllCompanyList().then(data => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          fromCompanyId: data.list,
        },
      }))
    })
  }

   // 转入账户筛选
   const getToAccountId = () => {
    api.getInnerFundTransferAccount().then(data => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          toAccountId: data.list,
        },
      }))
    })
  }

  // 转入主体 
  const getToCompanyList = () => {
    api.getAllCompanyList().then(data => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          toCompanyId: data.list,
        },
      }))
    })
  }

  // 分页点击
  const onChangeTable = (pagination, filters, sorter) => {
    const { current: page, pageSize: limit } = pagination
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...params,
        page: page,
        limit: limit,
      },
    }))
    history.replace(match.path + '?page=' + page + '&limit=' + limit)
  }

  // 点击筛选
  const onSubmit = (values) => {
    initParams.page = 1
    initParams.limit = 10
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...initParams,
        ...values,
      },
    }))
    history.replace(match.path)
  }

  // 预览/下载凭证
  const onVoucherAction = (record, download = false) => {
    api.getHost({}).then((res) => {
      if (download) {
        window.location = `${res.url}/api/File/downPdf?id=${record.id}&type=${'InnerFundTransferProof'}`
      } else {
        window.open(
          `${res.url}/api/File/prevPdf?id=${record.id}&type=${'InnerFundTransferProof'}`,
          '_blank'
        )
      }
    })
  }

  const columns = [
    {
      title: '订单编号',
      dataIndex: 'number',
      fixed: 'left',
      width: 140,
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入订单编号',
      },
    },
    {
      title: '业务编号',
      dataIndex: 'id',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入业务编号',
      },
      render: (text, record) => {
        return (
          <Link target='_blank'
            to={cryptoParamsIntoUrl('/corpAccount/InternalAccount/details', { id: record.id })}
          >
            {text}
          </Link>
        )
      },
    },
    {
      title: '转出账户',
      dataIndex: 'fromAccountId',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.fromAccountId.map((item) => ({
          label: item.accountName,
          value: item.id,
        })),
        onDropdownVisibleChange: (open) => {
          if (open) {
            getFromAccount()
          }
        },
      },
      render: (text, record) => record.fromAccountName,
    },
    {
      title: '转出账户主体',
      dataIndex: 'fromCompanyId',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.fromCompanyId.map((item) => ({
          label: item.name,
          value: item.id,
        })),
        onDropdownVisibleChange: (open) => {
          if (open) {
            getFromtCompanyList()
          }
        },
      },
      render: (text, record) => record.fromCompanyName,
    },
    {
      title: '转入账户',
      dataIndex: 'toAccountId',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.toAccountId.map((item) => ({
          label: item.accountName,
          value: item.id,
        })),
        onDropdownVisibleChange: (open) => {
          if (open) {
            getToAccountId()
          }
        },
      },
      render: (text, record) => record.toAccountName,
    },
    {
      title: '转入账户主体',
      dataIndex: 'toCompanyId',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.toCompanyId.map((item) => ({
          label: item.name,
          value: item.id,
        })),
        onDropdownVisibleChange: (open) => {
          if (open) {
            getToCompanyList()
          }
        },
      },
      render: (text, record) => record.toCompanyName,
    },
    { 
      title: '转款金额', 
      dataIndex: 'money',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入转款金额',
      },
    },
    {
      title: '申请人',
      dataIndex: 'applyStafName',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入申请人',
      },
    },
    {
      title: '申请时间',
      dataIndex: 'createTime',
      valueType: 'RangePicker',
      fieldProps: {
        allowClear: false,
      },
      search: {
        transform: (value) => {
          return {
            applyStart: value[0].format('YYYY-MM-DD'),
            applyEnd: value[1].format('YYYY-MM-DD'),
          }
        },
      },
    },
    { title: '付款开户行', dataIndex: 'fromBankOpen' },
    { title: '付款账号', dataIndex: 'fromBankNumber' },
    {
      title: '审批通过时间',
      dataIndex: 'auditTime',
      valueType: 'RangePicker',
      fieldProps: {
        allowClear: false,
      },
      search: {
        transform: (value) => {
          return {
            auditStart: value[0].format('YYYY-MM-DD'),
            auditEnd: value[1].format('YYYY-MM-DD'),
          }
        },
      },
    },
    {
      title: '银行支付日期',
      dataIndex: 'payTime',
    },
    {
      title: '回单归档时间',
      dataIndex: 'financeOpeTime',
      valueType: 'RangePicker',
      fieldProps: {
        allowClear: false,
      },
      search: {
        transform: (value) => {
          return {
            payStart: value[0].format('YYYY-MM-DD'),
            payEnd: value[1].format('YYYY-MM-DD'),
          }
        },
      },
    },
    {
      title: '操作',
      key: 'oprate',
      fixed: 'right',
      width: 120,
      render: (text, record) => {
        return (
          <>
            {record.hasPrev ?
              <Button
                type='link'
                size='small'
                onClick={() => onVoucherAction(record)}
              >
                凭证预览
             </Button> : null
            }
            {record.hasDown ?
              <Button
                  type='link'
                  size='small'
                  onClick={() => onVoucherAction(record, true)}
                >
                  下载凭证
              </Button> : null
            }
            <Button
              block
              type='link'
              size='small'
              style={{ color: record.hasModificationLog ? 'red' : ''}}
              onClick={() => handleEdit(record)}
            >
              付款信息修改
            </Button>
          </>
        )
      },
    },
  ]

  const handleEdit = data => {
    setEditData(data)
    setEditVisible(true)
  }

  return (
    <>
      <FormNoheader columns={columns} isNo={true} onSubmit={onSubmit} onReset={onSubmit} textFlag={false} />
      <div className='line'></div>
      <div className='add-wrap'>
        <Button
          type='primary'
          onClick={() => history.push('/settledList/InternalAccount/paymentlog')}
          style={{ marginRight: 10 }}
        >
          付款信息修改记录
        </Button>
        <Auth auths={authList} code='export'>
          <Button
            type='primary'
            title='导出'
            onClick={() => setShowExport(true)}
            style={{ marginRight: 10 }}
          >
            导出
           </Button>
        </Auth>
      </div>
      <Alert
        className='corp-count'
        message={`总计：${total}条数据`}
        type='info'
        showIcon
      />
      <Table
        size='small'
        columns={columns}
        dataSource={dataSource}
        rowKey='id'
        loading={loading}
        className='askforleave-table'
        pagination={{
          pageSize: parseInt(params.limit),
          total: total,
          current: parseInt(params.page),
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 2100 }}
      ></Table>
      <Export
        show={showExport}
        onCancel={() => {
          setShowExport(false)
          productsRef.current.changeVal()
        }}
        tplUrl='getTransferChangeExportTpl'
        fieldsUrl='getTransferChangeTplItems'
        saveUrl='saveTransferChangeExportTpls'
        exportUrl='exportTransferChange'
        method='export'
        parame={{
          ExportType: 'innerfundtransfer.export',
          ...exporfilter,
        }}
        cRef={productsRef}
      />
      <Drawer
        title="付款信息修改"
        width={600}
        onClose={() => setEditVisible(false)}
        visible={editVisible}
        destroyOnClose={true}
      >
        <EditPayment 
          setEditVisible={setEditVisible}
          getList={getList}
          editData={editData}
        />
      </Drawer>
    </>
  )
}

export default InternalAccount

